export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1711_.ddde354a.jpg";